import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { RiDeleteBin2Line } from "react-icons/ri";
import { HiOutlineDocumentText } from "react-icons/hi";
import { getPartnersDocData, addPartnersDocs, deletePartnerDocData } from "../../controllers/trainingPartners.controller"
import toast from 'react-hot-toast';
import Page from "../../Components/Page";
import { LuUsers } from 'react-icons/lu';

const TrainingPartnerDocs = () => {
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [viewDocUrl, setViewDocUrl] = useState(null);
    const fileInputRef = useRef(null); // Ref to the file input

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (selectedFiles.length === 0) {
            toast.error("Please select at least one file.");
            return;
        }

        try {
            const formData = new FormData();
            selectedFiles.forEach(file => {
                formData.append('files', file); // Append each file with the same field name
            });

            const res = await addPartnersDocs(formData); // Pass FormData
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                setSelectedFiles([]); // Clear selected files
                fetchTableData(); // Refresh table data
                if (fileInputRef.current) {
                  fileInputRef.current.value = ''; // Reset file input to allow re-selection of the same file(s)
                }
            } else {
                toast.error(message);
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.message || "Something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    };

    const fetchTableData = async () => {
        const res = await getPartnersDocData()

        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                id: d.id,
                file: d.file_path,
                url: d.file_url
            }))
            setData(tableData)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    const deleteTableRow = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deletePartnerDocData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    const handleViewDoc = (url) => {
      setViewDocUrl(url);
    };

    const closeViewDocModal = () => {
      setViewDocUrl(null);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };
    
    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        // Validate file types before adding them
        const pdfFiles = files.filter(file => file.type === "application/pdf");
    
        if (files.length !== pdfFiles.length) {
            toast.error("Only .pdf files are allowed.");
            return;
        }
        setSelectedFiles(prevFiles => [...prevFiles, ...pdfFiles]);
    };

    return (
        <div>
            <Page className="px-8 py-6">
                <div className="p-6">
                    <div className='flex items-center gap-10 text-xl'>
                        <div className="text-[#4B465C] ">
                            Career / <hi className="text-[black] bg-white mt-6"> Training Partner Documents</hi>
                        </div>
                    </div>
                    <div className="flex items-center mt-4 mb-4 space-x-4">
                        <button
                            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                            onClick={() => navigate("/sab/training-partners")}
                        >
                            <LuUsers className="mr-2" />
                            Training Partners
                        </button>
                        <button
                            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
                            onClick={() => navigate("/sab/training-partner-docs")}
                        >
                            <HiOutlineDocumentText className="mr-2" />
                            Training Partner Documents
                        </button>

                    </div>

                    <div className="container">
                        <div className="p-6 mx-auto bg-white rounded-lg shadow-md">
                            <form onSubmit={handleSubmit}>
                                <h1 className="mb-4 text-xl font-bold text-gray-700">Add Documents</h1>
                                <div className="mb-6">
                                    <h1 className="block text-black font-medium mb-2 text-[18px]" htmlFor="welcomeMessage">
                                        Files <b className="text-[#4B465C]">(Accept: .pdf)</b>
                                    </h1>
                                    {/* <div className="flex flex-col items-center justify-center h-auto mt-2 border-2 border-gray-300 border-dashed rounded-lg">
                                        {selectedFiles.length > 0 ? (
                                            <ul className="w-full p-4">
                                                {selectedFiles.map((file, index) => (
                                                    <li key={index} className="flex items-center justify-between py-2 border-b">
                                                        <span>{file.name}</span>
                                                        <button
                                                            onClick={() => handleRemoveFile(index)}
                                                            className="px-3 py-1 text-red-500 rounded hover:bg-red-100"
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <div className="p-4 text-gray-500">
                                                <div className="flex justify-center mb-4">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-10 h-10"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                    </svg>
                                                </div>
                                                <p className="ml-4">Upload files here</p>
                                                <p className="mb-4 text-sm text-center text-gray-400">
                                                    Accepts .pdf files
                                                </p>
                                                <label className="px-4 ml-4 mt-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                    <input
                                                        type="file"
                                                        accept=".pdf"
                                                        multiple
                                                        onChange={handleFileChange}
                                                        className="hidden"
                                                        ref={fileInputRef}
                                                    />
                                                    Browse files
                                                </label>
                                            </div>
                                        )}
                                    </div> */}
                                    <div
                                        className="flex flex-col items-center justify-center h-auto mt-2 border-2 border-gray-300 border-dashed rounded-lg"
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        {selectedFiles.length > 0 ? (
                                            <ul className="w-full p-4">
                                                {selectedFiles.map((file, index) => (
                                                    <li key={index} className="flex items-center justify-between py-2 border-b">
                                                        <span>{file.name}</span>
                                                        <button
                                                            onClick={() => handleRemoveFile(index)}
                                                            className="px-3 py-1 text-red-500 rounded hover:bg-red-100"
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <div className="p-4 text-gray-500">
                                                <div className="flex justify-center mb-4">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-10 h-10"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                    </svg>
                                                </div>
                                                <p className="ml-4">Drag and drop files here</p>
                                                <p className="mb-4 text-sm text-center text-gray-400">
                                                    Accepts .pdf files
                                                </p>
                                                <label className="px-4 ml-4 mt-4 py-2 text-[#92288C] rounded-md cursor-pointer border-2 border-[#92288C] hover:bg-[#92288C] hover:text-white">
                                                    <input
                                                        type="file"
                                                        accept=".pdf"
                                                        multiple
                                                        onChange={handleFileChange}
                                                        className="hidden"
                                                        ref={fileInputRef}
                                                    />
                                                    Browse files
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175] justify-end"
                                >
                                    Add
                                </button>
                            </form>
                        </div>

                        <div className="p-6 mx-auto mt-10 bg-white rounded-lg shadow-md">
                            <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                                <thead>
                                    <tr className="bg-gray-100 text-[#4B465C]">
                                        <th className="px-4 py-2 text-center">File</th>
                                        <th className="px-4 py-2 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => (
                                        <tr key={item.id} className="border-b hover:bg-gray-50">
                                            <td className="px-4 py-2 text-center">
                                                {item.file}
                                            </td>
                                            <td className="px-4 py-2 text-center">
                                                <div className="flex justify-center gap-4">
                                                    <button
                                                        onClick={() => {
                                                            setSelectedRowId(item.id);
                                                            document.getElementById("modal-delete").showModal();
                                                        }}
                                                        className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                    >
                                                        Delete
                                                        <RiDeleteBin2Line className="ml-2" />
                                                    </button>
                                                    <button
                                                        onClick={() => handleViewDoc(item.url)}
                                                         className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1"
                                                    >
                                                        View Doc
                                                        <HiOutlineDocumentText className="ml-2" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <dialog
                            id="modal-delete"
                            className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
                        >
                            <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">
                                        Delete
                                    </h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure?
                                    </p>
                                </div>
                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => {
                                            setSelectedRowId(null);
                                            document.getElementById("modal-delete").close();
                                        }}
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={async () => {
                                            deleteTableRow();
                                        }}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </dialog>

                       {/* View Document Modal */}
                       {viewDocUrl && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800/70 dark:bg-gray-800/80">
                          <div className="relative w-auto max-w-4xl">
                            <button
                              onClick={closeViewDocModal}
                              className="absolute top-0 right-0 p-2 text-white bg-gray-600 rounded-full hover:bg-gray-700"
                            >
                              X
                            </button>
                            <iframe
                              src={viewDocUrl}
                              title="View Document"
                              width="100%"
                              height="600px"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                </div>
            </Page>
        </div>
    )
}

export default TrainingPartnerDocs